import styled, { css } from 'styled-components';
import { Card } from '@bynder/design-system';

export const StyledCardImage = styled(Card.Img)<{ backgroundColor: string }>`
    ${(props) => css`
        background-color: ${props.backgroundColor};
    `}
`;
